import { bodyCopyXSmall, CircleBarChart, DateUtil, Divider, headlineExSmall, Loading } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import { IAudience } from '../../../models';
import { ProgressPanelStatus } from '../../../models/ProgressPanelStatus';
import { SurveyStatusType } from '../../../models/SurveyStatusType';
import { useProgressPanelState } from '../../../utilities/hooks/useProgressPanelState';
import { LoadingWrapper } from '../../common';

export const BodyCopyXSmall = styled.div`
	${bodyCopyXSmall}
`;
BodyCopyXSmall.displayName = 'BodyCopyXSmall';

export const HeadlineXSmall = styled('div')`
	${headlineExSmall}
`;
HeadlineXSmall.displayName = 'HeadlineXSmall';

export const FieldSpacer = styled.div`
	padding: 4px;
`;
FieldSpacer.displayName = 'FieldSpacer';

export const HeaderSpacer = styled.div`
	padding-bottom: 4px;
`;
HeaderSpacer.displayName = 'HeaderSpacer';

export const BottomDivider = styled(Divider)`
	margin-bottom: 0px;
`;
BottomDivider.displayName = 'BottomDivider';

export const Field = (props: { fieldName: string; fieldValue: string }) => {
	return (
		<FieldSpacer>
			<div className='row justify-content-between'>
				<BodyCopyXSmall className='col-6'>
					<b>{props.fieldName}</b>
				</BodyCopyXSmall>
				<BodyCopyXSmall className='col-6'>{props.fieldValue}</BodyCopyXSmall>
			</div>
		</FieldSpacer>
	);
};

export interface IProgressPanelProps {
	audienceId?: number;
	audiences: IAudience[];
	hasBeenPublished: boolean;
	isLoadingAudiences: boolean;
	surveyAdminSummaryLoading: boolean;
	surveyName: string;
	surveyStatus?: SurveyStatusType;
}

export const ProgressPanel = (props: IProgressPanelProps) => {
	const { surveyAdminSummaryLoading, isLoadingAudiences } = props;
	const { barChartProps, closeDateLabel, closeOn, header, openDateLabel, openOn, status } = useProgressPanelState(props);

	if (surveyAdminSummaryLoading || isLoadingAudiences) {
		return (
			<LoadingWrapper>
				<Loading height={'70px'} width={'70px'} />
			</LoadingWrapper>
		);
	} else {
		return (
			<>
				<CircleBarChart {...barChartProps} />
				<Divider type='dashed' />
				<HeaderSpacer>
					<div className='row no-gutters'>
						<div id='SurveyNameHeader' className='col'>
							<HeadlineXSmall>{header}</HeadlineXSmall>
						</div>
					</div>
				</HeaderSpacer>
				<Field fieldName={ContentConstants.SURVEY_ADMIN_PROGRESS_STATUS} fieldValue={status.toString()} />
				<Field fieldName={openDateLabel} fieldValue={formatDate(status, openOn)} />
				<Field fieldName={closeDateLabel} fieldValue={formatDate(status, closeOn)} />
				<BottomDivider type='dashed' />
			</>
		);
	}
};

function formatDate(status: ProgressPanelStatus, date?: string) {
	return date && status !== ProgressPanelStatus.Cancelled
		? DateUtil.formatDateToLocal(new Date(date))
		: ContentConstants.SURVEY_ADMIN_PROGRESS_DASHDASH;
}
